export default __webpack_public_path__ + "static/media/Tools-P17-CIFOR.01c7dcea.jpg";